// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cn-tabs{\n    width: 100%;\n    height: 50px;\n}\n\n.btn-tabs{\n    padding: 20px;\n    color: #9B9B9B;\n    cursor: pointer;\n}\n\n.btn-tabs:focus{\n    border: none;\n}\n\n.btn-active{\n    background-color: #003A66;\n    color: white;\n}\n.cn-tabs-content{\n    margin-top: 20px;\n}", ""]);
// Exports
module.exports = exports;
